import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@unite-us/ui';
import { TextButton } from '@unite-us/app-components';
import useServiceAuthorizationLineage from 'pages/service-authorizations/hooks/useServiceAuthorizationLineage';
import AuthorizationHistoryCard from './AuthorizationHistoryCard';

const AuthorizationHistoryButton = ({
  serviceAuthorization,
}) => {
  const modalRef = useRef();

  const {
    lineageAuthorizations,
  } = useServiceAuthorizationLineage(serviceAuthorization.original_service_authorization.id);

  const feeScheduleProgram = serviceAuthorization.fee_schedule_program;
  const lineage = lineageAuthorizations.map((auth) => ({
    ...auth,
    fee_schedule_program: feeScheduleProgram,
  }));

  const openModal = () => {
    if (modalRef.current) {
      modalRef.current.openDialog();
    }
  };

  const closeModal = () => {
    if (modalRef.current) {
      modalRef.current.closeDialog();
    }
  };

  return (
    <>
      <TextButton
        onClick={openModal}
        className="text-sm font-semibold leading-5 mt-2 outline-none focus:outline-none"
      >
        See details
      </TextButton>

      <Dialog
        ref={modalRef}
        title="Changes to authorization requested"
        size="large"
        onRequestClose={closeModal}
      >
        <div className="space-y-6">
          <h3 className="text-lg font-semibold leading-7 tracking-normal text-black">
            Current Authorization Request
          </h3>
          <AuthorizationHistoryCard
            authorization={lineage.at(-1)}
            lineage={lineage}
          />
          <h3 className="text-lg font-semibold leading-7 tracking-normal text-black">
            Previous Authorization Requests
          </h3>
          {lineage.slice(0, -1).reverse().map((auth) => (
            <AuthorizationHistoryCard
              key={auth.id}
              authorization={auth}
              lineage={lineage}
            />
          ))}
        </div>
      </Dialog>
    </>
  );
};

AuthorizationHistoryButton.propTypes = {
  serviceAuthorization: PropTypes.shape({
    id: PropTypes.string.isRequired,
    fee_schedule_program: PropTypes.object.isRequired,
    original_service_authorization: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default AuthorizationHistoryButton;
